// @core/api/endpoints/workflow/list_event_descriptors.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListEventDescriptorsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List event descriptors
 * Returns available platform events for configuring pipeline triggers. Supports filtering by product and category.
 */
export async function ListEventDescriptors(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListEventDescriptorsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/workflows/event-descriptors`;
  const requestOptions = options;
  return client.get<ListEventDescriptorsResponse>(requestPath, { ...requestOptions, params });
}
